export default __webpack_public_path__ + "static/media/linkedinlogo.238ec218.png";